import { isInvoiceAmountFilterValid } from "@/domain/invoices/invoiceFilterState";
import { mapPayLinkApiRow } from "@/domain/payLinks/mapPayLinkApiRow";
import type { PayLinkRow } from "@/domain/payLinks/payLinkRow";
import { searchPayLinks } from "@/features/invoices/api/searchPayLinks";
import type { InvoiceSearchRequest } from "@/types/api";
import { isoDateToUnixEnd, isoDateToUnixStart } from "@/utils/format/isoDate";

const COLLECT_PAGE_SIZE = 100;
const MAX_COLLECT_PAGES = 50;

function majorToMinorUnits(raw: string): number | undefined {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;
  const n = Number(trimmed);
  if (!Number.isFinite(n)) return undefined;
  return Math.round(n * 100);
}

export async function collectAllPayLinksForExport(params: {
  customerIds: string[];
  statuses: string[];
  dateFrom: string;
  dateTo: string;
  dueDateFrom: string;
  dueDateTo: string;
  amountMin: string;
  amountMax: string;
}): Promise<PayLinkRow[]> {
  const customer_ids =
    params.customerIds.length > 0 ? params.customerIds : undefined;
  const statuses =
    params.statuses.length > 0 ? params.statuses : undefined;

  const amountOk = isInvoiceAmountFilterValid(
    params.amountMin,
    params.amountMax,
  );
  const base: InvoiceSearchRequest = {
    page: 0,
    page_size: COLLECT_PAGE_SIZE,
    customer_ids,
    statuses,
    created_from: isoDateToUnixStart(params.dateFrom),
    created_to: isoDateToUnixEnd(params.dateTo),
    due_from: isoDateToUnixStart(params.dueDateFrom),
    due_to: isoDateToUnixEnd(params.dueDateTo),
    ...(amountOk
      ? {
          amount_due_min: majorToMinorUnits(params.amountMin),
          amount_due_max: majorToMinorUnits(params.amountMax),
        }
      : {}),
  };

  const all: PayLinkRow[] = [];
  let after: string | undefined;
  for (let page = 0; page < MAX_COLLECT_PAGES; page++) {
    const res = await searchPayLinks({
      ...base,
      after_invoice_id: after,
    });
    all.push(...res.items.map(mapPayLinkApiRow));
    if (!res.has_more || !res.next_cursor) {
      break;
    }
    after = res.next_cursor;
  }
  return all;
}
